function LogoSlider(){
    jQuery(function(){
        jQuery('.logo__slider').slick({
                 //options
                 infinite: true,
                 slidesToShow: 4,
                 slidesToScroll: 1,
                //  centerPadding : 500,
      
                 arrows: true,
                 autoplay: true,
                 autoplaySpeed: 2000,
                 pauseOnHover:false,
                 fade: false,
                 cssEase: 'linear',
                 variableWidth: true,
                 responsive: [
                    {
                      breakpoint: 900,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                       // dots: true,
                        autoplay: true,
                        arrows: true,
                       
                      }
                    },

                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                       // dots: true,
                        autoplay: true,
                        arrows: true,
                       
                      }
                    },

                ]
        });
      });
}
export default LogoSlider;